import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { FaqItemDto } from '@lex/contracts';
import { Button } from '@lex/ui';
import { MinusIcon, PlusIcon } from '../icons';
import { Glow, SectionHeader } from './primitives';

export function FaqItem({
  item,
  open,
  onToggle,
}: {
  item: FaqItemDto;
  open: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="rounded-3xl border border-line bg-white px-5 py-5 md:px-7">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-center gap-4 text-left"
      >
        <span className="flex-1 text-[17px] font-semibold leading-snug text-ink md:text-[19px]">
          {item.question}
        </span>
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-soft text-accent">
          {open ? <MinusIcon className="h-4 w-4" /> : <PlusIcon className="h-4 w-4" />}
        </span>
      </button>
      {open ? (
        <p className="mt-3 text-[15px] leading-[1.6] text-muted md:text-base">{item.answer}</p>
      ) : null}
    </div>
  );
}

export function FaqSection({ faq }: { faq: FaqItemDto[] }) {
  const navigate = useNavigate();
  const [openId, setOpenId] = useState<string | null>(faq[0]?.id ?? null);

  return (
    <section id="faq" className="scroll-mt-24 relative overflow-hidden px-4 py-14 md:px-8 md:py-20 xl:px-20">
      <Glow color="gold" size={380} opacity={0.18} blur={70} className="-left-20 top-24 hidden lg:block" />

      <div className="relative mx-auto grid max-w-[1280px] gap-10 lg:grid-cols-[400px_1fr] lg:gap-16">
        <div className="flex flex-col items-start gap-5">
          <SectionHeader eyebrow="FAQ" title="Частые вопросы" />
          <p className="text-[16px] leading-[1.5] text-muted md:text-[18px]">
            Не нашли ответ? Задайте вопрос юристу прямо в чате — ответим по вашей ситуации.
          </p>
          <Button variant="ink" size="lg" className="rounded-xl" onClick={() => navigate('/chat')}>
            Задать вопрос
          </Button>
        </div>

        <div className="flex flex-col gap-3">
          {faq.map((item) => (
            <FaqItem
              key={item.id}
              item={item}
              open={openId === item.id}
              onToggle={() => setOpenId((current) => (current === item.id ? null : item.id))}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
